module.exports = __webpack_public_path__ + "static/media/Carp.metal.b6396d45.png";